import React from "react";

const SelectField = (props: any) => {
  return (
    <>
      <div className="form-floating">
        <select className="form-select" {...props}>
          {props?.children}
        </select>
        <label htmlFor="floatingSelect">{props?.placeholder}</label>
      </div>
    </>
  );
};

export default SelectField;
